// extracted by mini-css-extract-plugin
module.exports = {"pt-claim-application-iframe":"pt-claim-application-iframe-fe495730999b6a93560a721923f44b68"};